import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import MenuBar from "../../components/menu-bar/MenuBar";
import { Redirect } from "react-router-dom";
import {
  UpdateCartCount,
  UpdateCartAmount,
  setACF,
} from "../../redux/actions/postActions";
import { WebApiCalls } from "../../webApiCalls/webApiCalls";
import MyStorage from "../../common/MyStorage";
import { formatCurrency } from "../../common/format-currency";
import { userLogout } from "../../redux/actions/postActions";
import Loader from "react-loader-spinner";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import { KMTracking } from "../../components/Tracking/KMTracking";
import _ from "lodash";
import ProductDesc from "../product-description/ProductDesc";

declare const window: any;
var ACF;
const grabPayCode = "GRAB";
const ocbcPayCode = "PAYANYONE";
const shopBackCode = "HOOLAH";
const aliPayCode = "ALIPAY";
const weChatPayCode = "WCQR";
const payNowCode=  "PNQR"
const installmentPlanCode="IPP"
const aliPayImage = "images/aliPay.png";
const grabPayImage = "images/grabPay.png";
const weChatPayImage = "images/weChat.png";
const ocbcPayImage = "images/ocbc.png";
const shopBackImage = "images/shopback.png";
const payNowImage=  "images/paynow_61x61.png"
const installmentPlanImage="images/MaterCard.png"

function SelectPaymentMethod(props) {
  //custom hook for set state with callback fn
  const useStateWithCallback = (initialState) => {
    const [state, setState] = useState(initialState);
    const callbackRef = useRef(() => undefined);

    const setStateCB = (newState, callback) => {
      callbackRef.current = callback;
      setState(newState);
    };

    useEffect(() => {
      callbackRef.current?.();
    }, [state]);

    return [state, setStateCB];
  };
  const [payment, setPayment] = useState([
    {
      title: "New Credit Card",
      isDefault: true,
      ending: 7785,
      isDeleteAble: true,
      code: "123",
    },
  ]);
  const [invoiceSpinner, setInvoiceSpinner] = useState(false);
  const [paymentCode, setPaymentCode] = useState("");
  const [subTotal, setSubTotal] = useState(0);
  const [deleiverySelectPrice, setDeleiverySelectPrice] = useState(0);
  const [couponCodePrice, setCouponCodePrice] = useState(0);
  const [methodRadio, setMethodRadio] = useState("");
  const [show_method_error, setShowMethodError] = useState(false);
  // const [merchatArray, setMerchatArray] = useState([])
  const [merchatArray, setMerchatArray] = useStateWithCallback([]);
  const [data, setData] = useState([]);
  const [selected_type, setSelectedType] = useState("");
  const [partner_payment_option, setPartnerPaymentOption] = useState("");
  const [selectedCardType, setSelectedCardType] = useState<any>("");
  const [is_loading, setIsLoading] = useState(false);
  const [errorDescription, setErrorDescription] = useState("");
  const [show_error_modal, setShow_error_modal] = useState(false);
  const [promoObjInvoice, setPromoObjInvoice] = useState<any>({});
  const [promoObjFromProps, setPromoObjFromProps] = useState<any>({});
  const [discountMerchantID, setDiscountMerchantID] = useState<any>({});
  const [paymentMethodfrhub, setPaymentMethodFrhub] = useState<any>([]);

  let tryCount = 0;
  useEffect(() => {
    window.scrollTo(0, 0);
    getPaymentToken("");
    let subTotal: any = new MyStorage().getCartAmount();
    setSubTotal(subTotal);
    // console.log("Props here:  ", props)
    let promoResponse: any = props.location.state?.couponCode;
    setPromoObjFromProps(promoResponse);
    // console.log("Checking Promo Data in select payment Method screen", promoResponse, JSON.parse(promoResponse?.discount_merchants)[0]?.value)
    let promoObj;
    if (promoResponse) {
      promoObj = {
        code: promoResponse?.promoCode,
        merchantID: JSON.parse(promoResponse?.discount_merchants)[0]?.value,
        invoice_amount: promoResponse?.total,
        order_amount: promoResponse?.sum_of_discount_products_before_discount,
        order_discount_amount: promoResponse?.applied_discount_amount,
        products:
          Object.keys(promoResponse?.products).length > 0
            ? Object.keys(promoResponse.products)
            : "",
        discount_type: promoResponse?.discount_type
          ? promoResponse?.discount_type
          : "",
        discount_value: promoResponse?.discount_amount
          ? promoResponse?.discount_amount
          : "",
        min_spend: promoResponse?.min_spend,
        max_discount: promoResponse?.max_discount,
        entire_store: promoResponse?.entire_store,
        bundle: promoResponse?.bundle,
      };
    } else {
      promoObj = "";
    }

    setPromoObjInvoice(promoObj);
    console.log("Checking promo object", promoObj);
    if (!_.isEmpty(props?.acf)) {
      ACF = props?.acf;
    } else {
      ACF = new WebApiCalls().getCustomFieldsCode(true);
      props.setACF(ACF);
    }
  }, []);
  useEffect(() => {
    // console.log("Props here:  ", props)
    const overlay = document.querySelector(".overlay");
    overlay?.addEventListener("click", function (event) {
      setShow_error_modal(false);
    });
  }, [show_error_modal]);

  useEffect(() => {
    getFrhubSettings();
  }, []);

  const tracker = async (eventName, _kmprops) => {
    await KMTracking(eventName, _kmprops);
  };

  const getFrhubSettings = () => {
    new WebApiCalls()
      .getAppSettings()
      .then(async (result) => {
        result?.data?.Items.map((item) => {
          if (item.item_name == "payment_methods_estore") {
            console.log("here is the payment method detail--->", item.item_detail);
            setPaymentMethodFrhub(item.item_detail);
          }
        });
      })
      .catch((error) => {
        console.log("Error: ", error);
      });
  };

  const getPaymentToken = async (_accessToken) => {
    setInvoiceSpinner(true);
    let accessToken: any = "";
    if (_accessToken) {
      accessToken = _accessToken;
    } else {
      accessToken = await localStorage.getItem("authenticationFrasers");
      // accessToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJkYXRhIjp7InN0YXR1cyI6InN1Y2Nlc3MiLCJpc19tZW1iZXIiOiJZIiwiaXNfYXBwcm92ZWQiOiJZIiwidGNfYWdyZWVkIjoiWSIsInNlc3Npb25fdG9rZW4iOiI2YjBmMGM5M2IzMWFiZmZiMGU4MTU1ZTQ5YWMwNmE3NiIsInBhc3N3b3JkX3Jlc2V0IjoiTiIsIm1lbWJlcl9pZCI6IjE4MzAxOCIsImNvbnRhY3RfaWQiOiI1MDA4NjMiLCJkdXBsaWNhdGUiOiJOIn0sImlhdCI6MTYwNzQyMDI1MiwiZXhwIjoxNjEwMDEyMjUyfQ.ZNxTzkznHhNe5lIx68cE3JcjmdVD0s-55t-8Izzfr00"
    }
    // let userID = await localStorage.getItem("UserId")
    await new WebApiCalls().getPaymentToken(accessToken).then((response) => {
      if (response.statusCode == 200 && response.data) {
        if (response.data.payment_token) {
          payment.unshift(response.data);
          setPaymentCode(response.data.payment_token);
          setInvoiceSpinner(false);
        }
      } else if (response.statusCode == 400) {
        if (tryCount == 0) {
          tryCount = tryCount + 1;
          getTokenAgain();
        } else {
          // setPayment([])
          // new MyStorage().clearStorage()
          // props.userLogout();
          // localStorage.clear()
          // props?.history?.push("/login",{from:'Checkout'})
          // console.log('Session Expired')
        }
      } else {
        if (tryCount == 0) {
          tryCount = tryCount + 1;
          getTokenAgain();
        } else {
          // new MyStorage().clearStorage()
          // props.userLogout();
          // localStorage.clear()
          // props?.history?.push("/login",{from:'Checkout'})
          // console.log('Session Expired')
        }
        setInvoiceSpinner(false);
      }
    });
  };

  const getTokenAgain = async () => {
    let _name = await localStorage.getItem("name");
    let _contactID = await localStorage.getItem("contactIDFrasers");
    let _email = await localStorage.getItem("emailFrasers");
    let _phoneNumber = await localStorage.getItem("PhoneNumber");
    let _token = await localStorage.getItem("authenticationFrasers");
    let obj = {
      contact_id: _contactID,
      email: _email,
      phoneNumber: _phoneNumber,
      authenticationFrasers: _token,
      name: _name,
      authentication: _token,
    };
    fetchingToken(obj);
  };

  const fetchingToken = async (data) => {
    let obj = {
      contactID: data.contact_id,
      email: data.email,
      authentication: data.authentication,
      phoneNumber: data.phoneNumber,
      name: data.name,
    };
    localStorage.setItem("contactIDFrasers", obj.contactID);
    localStorage.setItem("emailFrasers", obj.email);
    localStorage.setItem("authenticationFrasers", obj.authentication);
    localStorage.setItem("PhoneNumber", obj.phoneNumber);
    localStorage.setItem("name", obj.name);
    const storage = new MyStorage();
    let userID = storage.getUserId();

    let access_token = storage.getaccess_token();
    let ssoCode = storage.getSsoCode();
    if (!userID && !access_token && !ssoCode) {
      await new WebApiCalls().getToken(obj).then(async (response) => {
        if (response.AccessToken) {
          localStorage.setItem("UserId", response.AccessToken.UserId);
          localStorage.setItem(
            "access_token",
            response.AccessToken.access_token
          );
          localStorage.setItem("SsoCode", response.SsoCode);
          getPaymentToken(response.AccessToken.access_token);
        }
      });
    }
  };

  const getInvoice = async () => {
    setIsLoading(true);

    let TotalPrice: any = 0;
    if (subTotal !== null) {
      TotalPrice = formatCurrency(subTotal);
    }
    let cartItems = props?.location?.state?.productsID;
    setInvoiceSpinner(true);
    let userID = localStorage.getItem("UserId");
    let accessToken = localStorage.getItem("access_token");
    let data = {
      "Order total": TotalPrice,
      Currency: "SGD",
      "Product quantity": props.cart_count,
      "Total discount": "",
      "Coupon code": "",
      Fulfilment: props?.location?.state?.type,
    };

    tracker("placedorder", data);

    if (props?.location?.state?.type === "delivery") {
      let carthasDelivery = false; //to check if delivery item is already in cart
      let cartResponseBefore = await new WebApiCalls().seeCart(
        userID,
        accessToken
      ); //get cart before adding delivery item
      cartResponseBefore?.Records?.map((item) => {
        if (item.ItemDetail.Name == "Delivery") {
          carthasDelivery = true;
        }
      });
      if (!carthasDelivery && props?.location?.state?.frasersDelivery) {
        let deliveryItemAdded = await addDeliveryItemToCart();
      }
      let cartResponse = await new WebApiCalls().seeCart(userID, accessToken);
      cartItems = cartResponse.Records.map((item) => item.ID);
    }
    invoiceGenerateFunction(cartItems);
  };

  const invoiceGenerateFunction = async (itemObj) => {
    // this.setState({ invoiceSpinner: true })
    let userID = await localStorage.getItem("UserId");
    let accessToken = await localStorage.getItem("access_token");
    let invoiceResponse = await new WebApiCalls().getInvoice(
      userID,
      itemObj,
      accessToken
    );
    let couponObject = promoObjInvoice;

    // MyStorage().

    // console.log("Invoice Code result: ", invoiceResponse, couponObject)

    if (invoiceResponse.Code) {
      setInvoiceSpinner(true);
      setErrorDescription(invoiceResponse.InnerErrors[0].Message);
      setShow_error_modal(true);
      setIsLoading(false);
      // this.setState({
      //   invoiceSpinner: false,
      //   show_error_modal: true,
      //   errorDescription: invoiceResponse.InnerErrors[0].Message
      // })
    } else {
      let ammount = 0;
      let merchantArray: any = [];
      let userDefined4TempArray: any = [];
      await Promise.all(
        invoiceResponse.Orders?.map(async (item, index) => {
          console.log("Checking sub merchants", item);
          let merchantDetails = await new WebApiCalls().getUserDetail(
            item.MerchantDetail.ID
          );
          // Extract the 2c2p Sub Merchant ID
          let MerchantCF = merchantDetails.CustomFields;

          let SubMerchantID: any = "000000000000";
          if (MerchantCF) {
            SubMerchantID = MerchantCF.filter(
              (mcf) => mcf["Code"] === ACF["2c2p Sub Mid"]
            );
            SubMerchantID =
              SubMerchantID.length > 0
                ? SubMerchantID[0].Values[0]
                : "000000000000";
          }
          if (SubMerchantID == promoObjFromProps?.subMID) {
            ammount =
              ammount +
              (item.Total - promoObjFromProps?.applied_discount_amount);
          } else {
            ammount = ammount + item.Total;
          }

          if (item.Total > 0) {
            // 2c2p doesn't process 0$ orders
            merchantArray.push({
              merchantID: SubMerchantID,
              amount:
                promoObjFromProps?.subMID == SubMerchantID
                  ? (
                      item.Total - promoObjFromProps?.applied_discount_amount
                    ).toString()
                  : item.Total.toString(),
              invoiceNo: invoiceResponse.InvoiceNo.toString(),
              description: "order_id: " + item.ID,
            });
            userDefined4TempArray.push({
              merchant_id: SubMerchantID,
              amount:
                promoObjFromProps?.subMID == SubMerchantID
                  ? (
                      100 *
                      (item.Total - promoObjFromProps?.applied_discount_amount)
                    ).toString()
                  : (item.Total * 100).toString(),
              order_id: invoiceResponse.InvoiceNo.toString(),
              transaction_ref: Math.floor(Math.random() * 1000) + 1,
            });
          }
        })
      );
      console.log(
        "Checking Merchant Array",
        merchantArray,
        couponObject,
        ammount
      );

      await setMerchatArray(merchantArray, async () => {
        let addCustomFieldsResponse = await addCustomField(invoiceResponse);
        await getHash(
          invoiceResponse,
          ammount,
          merchantArray,
          userDefined4TempArray
        );
      });
    }
  };

  const addCustomField = async (data) => {
    // let accessToken = await localStorage.getItem("access_token");
    const contactId = localStorage.getItem("contactIDFrasers");
    let userID = await localStorage.getItem("UserId");
    let x = await new WebApiCalls().getUserInfo(userID);
    const email = await x.Email;
    const phone = await x.PhoneNumber;
    const name = (await x?.FirstName) + " " + x?.LastName;
    const authentication = localStorage.getItem("authenticationFrasers");
    let body = {
      type: props.location.state.type,
      data: [
        {
          invoice: data.InvoiceNo,
          address_id:
            props?.history?.location?.state?.deliveryAddress.address_id,
          contactId: contactId,
          delivery_address: props.history.location.state.deliveryAddress,
          buyer_info: { name, email, phone },
          securityToken: authentication,
          coupon_code: promoObjInvoice,
        },
      ],
    };
    console.log("Data is here:  ", data);
    return new WebApiCalls().setCustomField(body,authentication);
  };

  const getHash = async (
    data,
    ammount,
    merchantArray,
    userDefined4TempArray
  ) => {
    let userID = await localStorage.getItem("UserId");
    let accessToken = await localStorage.getItem("authenticationFrasers");
    let body = {
      merchantID: "702702000000639",
      description: "Frasers eStore",
      invoiceNo: data.InvoiceNo,
      currencyCode: "SGD",
      amount: ammount,
      version: "8.9",
      paymentChannel:
        selected_type == "partners" ? [partner_payment_option] : ["CC"],
      subMerchants: merchantArray,
      userDefined1: localStorage.getItem("contactIDFrasers"),
      userDefined2: process.env.REACT_APP_ENV,
      userDefined3: "website",
      userDefined4: "",
      frontendReturnUrl: process.env.REACT_APP_2C2P_frontendReturnUrl,
      backendReturnUrl: process.env.REACT_APP_2C2P_backendReturnUrl,
    };
    if (selected_type !== "partners") {
      body["Tokenize"] = true;
      body["cardTokens"] =
        selectedCardType == 0 ? (paymentCode ? [paymentCode] : "") : "";
      body["cardTokenOnly"] =
        selectedCardType == 0 ? (paymentCode ? true : false) : false;
    }
    console.log("Debug: body =====> ", body);
    await new WebApiCalls()
      .getHash(body, accessToken)
      .then(async (response) => {
        console.log("Debug: response =====> ", response);
        setIsLoading(false);
        setData(response.data);
        let redirecturl = response.webPaymentUrl;
        localStorage.setItem("2c2p-PaymentToken", response.paymentToken);
        window.open(redirecturl, "_self");
        setTimeout(() => {
          if (window.myform) {
            const data = {
              name: "wentTo2C2P",
              data: {
                totalItems: 0,
              },
              page: "select-payment-method",
              navigate: "/my-bag",
            };
          }
        }, 100);
      });
  };

  const checkPaymentOptions = (item) => {
    // 1 means new credit card, 0 means from listing api
    if (
      item.payment_type &&
      (item.payment_type.includes("Mastercard") ||
        item.payment_type.includes("MasterCard"))
    ) {
      setSelectedCardType(0);
    } else if (
      item.payment_type &&
      (item.payment_type.includes("visa") || item.payment_type.includes("Visa"))
    ) {
      setSelectedCardType(0);
    } else if (item.title.includes("Credit")) {
      setSelectedCardType(1);
    }
  };

  const addDeliveryItemToCart = async () => {
    let itemObj = {
      ItemDetail: {
        ID: ACF["FrasersDeliveryItemID"],
      },
      Quantity: 1,
    };
    // this.setState({ addTocartSpinner: true });
    let userID = await localStorage.getItem("UserId");
    let accessToken = await localStorage.getItem("access_token");
    return new WebApiCalls().addItem(userID, itemObj, accessToken);
  };

  let cardImage = "";
  let cardImage2 = "";

  // const redirectPaymentUrl = () => {
  //   const _data: any = data;
  //   let data1 = {};
  //   if (_data && _data.body) {
  //     data1 = {
  //       userDefined1: _data.body?.user_defined_1,
  //       userDefined2: _data.body?.user_defined_2,
  //       userDefined3: _data.body?.user_defined_3,
  //       merchantID: _data.body?.merchant_id,
  //       frontendReturnUrl: process.env.REACT_APP_2C2P_frontendReturnUrl,
  //       backendReturnUrl: process.env.REACT_APP_2C2P_backendReturnUrl,
  //       tokenize: _data.body?.enable_store_card,
  //       paymentChannel: _data.body?.payment_option,
  //       description: _data.body?.payment_description,
  //       invoiceNo: _data.body?.order_id,
  //       amount: _data.body?.amount,
  //       subMerchants: _data?.sub_merchant_list,
  //       ...(_data.body?.storeuniqueid
  //         ? { stored_card_unique_id: _data.body?.storeuniqueid }
  //         : {}),
  //       use_storedcard_only: _data.body?.use_storedcard_only,
  //     };
  //     // let url = "https://sandbox-pgw.2c2p.com/payment/4.1/paymentToken";
  //     // let request = {
  //     //   method: "POST",
  //     //   body: JSON.stringify(data1),
  //     //   headers: {
  //     //     "Content-Type": "application/json",
  //     //   },
  //     // };
  //     // let work = new WebApiCalls().sendRequest(url, request);
  //     // return work;
  //   }

  //   return (
  //     <div style={{ width: 0, height: 0 }}>
  //       {_data ? (
  //         <form
  //           id="myform"
  //           name="myform"
  //           method="post"
  //           action={process.env.REACT_APP_2C2P_REDIRECT_API_FORM_ACTION_URL}
  //           onSubmit={() => {
  //             setInvoiceSpinner(false);
  //           }}
  //         >
  //           <input type="hidden" name="version" value={_data?.body?.version} />
  //           <input
  //             type="hidden"
  //             name="user_defined_1"
  //             value={_data.body?.user_defined_1}
  //           />
  //           <input
  //             type="hidden"
  //             name="user_defined_2"
  //             value={_data.body?.user_defined_2}
  //           />
  //           <input type="hidden" name="user_defined_3" value="website" />
  //           <input
  //             type="hidden"
  //             name="merchant_id"
  //             value={_data.body?.merchant_id}
  //           />
  //           <input type="hidden" name="currency" value={_data.body?.currency} />
  //           <input
  //             type="hidden"
  //             name="result_url_1"
  //             value={`${process.env.REACT_APP_2C2P_RESULT_URL_1}`}
  //           />
  //           <input
  //             type="hidden"
  //             name="result_url_2"
  //             value={`${process.env.REACT_APP_2C2P_RESULT_URL_2}`}
  //           />
  //           <input
  //             type="hidden"
  //             name="enable_store_card"
  //             value={_data.body?.enable_store_card}
  //           />
  //           <input type="hidden" name="hash_value" value={_data.hash} />
  //           <input
  //             type="hidden"
  //             name="payment_option"
  //             value={_data.body?.payment_option}
  //           />
  //           <input
  //             type="hidden"
  //             name="payment_description"
  //             value={_data.body?.payment_description}
  //             readOnly
  //           />
  //           <br />
  //           <input
  //             type="hidden"
  //             name="order_id"
  //             value={_data.body?.order_id}
  //             readOnly
  //           />
  //           <br />
  //           <input
  //             type="hidden"
  //             name="amount"
  //             value={_data.body?.amount}
  //             readOnly
  //           />
  //           <br />
  //           <input
  //             type="hidden"
  //             name="sub_merchant_list"
  //             value={_data.sub_merchant_list}
  //             readOnly
  //           />
  //           {_data.body?.storeuniqueid && (
  //             <input
  //               type="hidden"
  //               name="stored_card_unique_id"
  //               value={_data.body?.storeuniqueid}
  //               readOnly
  //             />
  //           )}
  //           <input
  //             type="hidden"
  //             name="use_storedcard_only"
  //             value={_data.body?.use_storedcard_only}
  //             readOnly
  //           />
  //           <br />
  //           <input
  //             type="hidden"
  //             name="btnSubmit"
  //             value="Confirm"
  //             style={{ width: 0, height: 0 }}
  //           />
  //         </form>
  //       ) : null}
  //     </div>
  //   );
  // };

  const renderNewPaymentPartners = (id, _img, title, code) => {
    return (
      <label className="entry">
        <div className={"info"}>
          <div className="card-type">
            <img src={_img} alt="" />
          </div>
          {title}
        </div>
        <input
          value={code}
          type="radio"
          name="card"
          onChange={(text: any) => {
            console.log("texttexttext = ", text);
            setMethodRadio(text);
            setShowMethodError(false);
            setSelectedType("partners");
            setPartnerPaymentOption(text.target.defaultValue);
          }}
        />
      </label>
    );
  };

  const renderOCBCPaymentPartners = (id, _img, title, code) => {
    return (
      <label className="entry set-mobile-screen">
        <div className={"info"}>
          <div className="card-type">
            <img src={_img} alt="" />
          </div>
          {title}
        </div>
        <input
          value={code}
          type="radio"
          name="card"
          onChange={(text: any) => {
            console.log("texttexttext = ", text);
            setMethodRadio(text);
            setShowMethodError(false);
            setSelectedType("partners");
            setPartnerPaymentOption(text.target.defaultValue);
          }}
        />
      </label>
    );
  };
  const renderShopBack = (id, _img, title, code) => {
    return (
      <label className="entry">
        <div className={"info"}>
          <div className="card-type">
            <img src={_img} alt="" />
          </div>
          {title}
        </div>
        <input
          value={code}
          type="radio"
          name="card"
          onChange={(text: any) => {
            console.log("texttexttext = ", text);
            setMethodRadio(text);
            setShowMethodError(false);
            setSelectedType("partners");
            setPartnerPaymentOption(text.target.defaultValue);
          }}
        />
      </label>
    );
  };

  const renderPayNowPaymentPartners = (id, _img, title, code) => {
    return (
      <label className="entry">
        <div className={"info"}>
          <div className="card-type">
            <img src={_img} alt="" />
          </div>
          {title}
        </div>
        <input
          value={code}
          type="radio"
          name="card"
          onChange={(text: any) => {
            console.log("texttexttext = ", text);
            setMethodRadio(text);
            setShowMethodError(false);
            setSelectedType("partners");
            setPartnerPaymentOption(text.target.defaultValue);
          }}
        />
      </label>
    );
  };
  const renderInstallmentPlanPartners = (id, _img, title, code) => {
    return (
      <label className="entry">
        <div className={"info"}>
        <div className="installment">
        <img src="images/paylater.png" alt="" />
       </div>
        {/* <div className="card-type">
          <img src="images/icon-visa.png" alt="" />
        </div> */}
          {/* <div className="card-type">
            <img src={_img} alt="" />
          </div> */}
        <div style={{marginRight:'10px'}}>{title}</div>
        </div>
        <input
          value={code}
          type="radio"
          name="card"
          onChange={(text: any) => {
            console.log("texttexttext = ", text);
            setMethodRadio(text);
            setShowMethodError(false);
            setSelectedType("partners");
            setPartnerPaymentOption(text.target.defaultValue);
          }}
        />
      </label>
    );
  };
  console.log("fere is", paymentMethodfrhub);
  return (
    <div>
      <div className="viewport"></div>
      {/* {redirectPaymentUrl()} */}

      {/* /container */}
      <div className="container">
        {/* header */}
        <Header props={props} />
        {/* /header */}

        <MenuBar
          props={props}
          categoriesArray={props?.allCategories ? props?.allCategories : []}
        />

        {/* <!-- /content --> */}
        <div className="content">
          {/* <!-- checkout --> */}
          <div className="checkout">
            {/* <!-- left --> */}
            <div className="left-column">
              {/* <!-- address-list --> */}
              <div className="address-list payment-cards payment-page">
                {/* <!-- entry --> */}

                {paymentMethodfrhub?.includes("CC") &&
                  payment.map((item: any, index) => {
                    if (
                      item.payment_type &&
                      (item.payment_type.includes("Mastercard") ||
                        item.payment_type.includes("MasterCard"))
                    ) {
                      cardImage = "images/icon-mastercard.png";
                    } else if (
                      item.payment_type &&
                      (item.payment_type.includes("visa") ||
                        item.payment_type.includes("Visa"))
                    ) {
                      cardImage = "images/icon-visa.png";
                    } else if (item.title.includes("Credit")) {
                      cardImage = "images/icon-mastercard.png";
                      cardImage2 = "images/paymark_masterc1.png";
                    }
                    return (
                      <label key={index} className="entry">
                        {item.payment_type ? (
                          <div className="info">
                            <div className="card-type">
                              <img src={cardImage} alt="" />
                            </div>
                            {item.title}
                          </div>
                        ) : (
                          <div className="info">
                            <div className="card-type">
                              <img src="images/master_card.png" alt="" />
                            </div>
                            <div className="card-type">
                              <img src="images/icon-visa.png" alt="" />
                            </div>
                            {item.title}
                          </div>
                        )}
                        <input
                          type="radio"
                          name="card"
                          onChange={(text: any) => {
                            setMethodRadio(text);
                            setShowMethodError(false);
                            checkPaymentOptions(item);
                          }}
                        />
                      </label>
                    );
                  })}
                  {(subTotal >= 100 && paymentMethodfrhub?.includes("Installment_Payment_Plan")) &&
                  renderInstallmentPlanPartners(
                    0,
                    installmentPlanImage,
                    "Pay Later by DBS/POSB or HSBC Cards",
                    installmentPlanCode
                  )}
                {paymentMethodfrhub?.includes("grab_otc") &&
                  renderNewPaymentPartners(
                    0,
                    grabPayImage,
                    "GrabPay",
                    grabPayCode
                  )}               
                  {paymentMethodfrhub?.includes("PayNowQR") &&
                  renderPayNowPaymentPartners(
                    0,
                    payNowImage,
                    "PayNow",
                    payNowCode
                  )}
                  {paymentMethodfrhub?.includes("ocbc_paynow") &&
                  renderOCBCPaymentPartners(
                    0,
                    ocbcPayImage,
                    "OCBC Digital",
                    ocbcPayCode
                  )}
                {subTotal > 5 && paymentMethodfrhub?.includes("shop_back") &&
                  renderShopBack(
                    0,
                    shopBackImage,
                    "ShopBack",
                    shopBackCode
                  )}

                {show_method_error && (
                  <div style={{ display: "block" }} className="error">
                    {"Please select payment method"}
                  </div>
                )}

                {/* <!-- /entry --> */}

                {/* <!-- entry --> */}
                {/* <label className="entry">

                                    <div className="info">
                                        <div className="card-type">
                                            <img src="images/icon-mastercard.png" alt="" />
                                        </div>
                                        <div className="card-type">
                                            <img src="images/icon-visa.png" alt="" />
                                        </div>
								Add New Card
							</div>
                                    <input type="radio" name="card" />

                                </label> */}
                {/* <!-- /entry --> */}
              </div>
              {/* <!-- /address-list --> */}
            </div>
            {/* <!-- /left --> */}

            {/* <!-- right --> */}
            <div className="right-column">
              {/* <!-- checkout-box --> */}
              <div className="checkout-box">
                {/* <!-- order-summary --> */}
                <div className="order-summary no-border">
                  <div className="title">Order Summary</div>

                  {/* <!-- subtotal --> */}
                  <div className="sub">
                    {/* <!-- subtotal --> */}
                    <div className="fees items">
                      <div className="text">Subtotal</div>
                      <div className="price">{formatCurrency(subTotal)}</div>
                    </div>
                    {/* <!-- /subtotal --> */}

                    {/* <!-- deliveryfee --> */}
                    <div className="fees delivery">
                      <div className="text">Delivery</div>
                      <div className="price">$10.00</div>
                    </div>
                    {/* <!-- /deliveryfee --> */}
                  </div>
                  {/* <!-- /subtotal --> */}

                  {/* <!-- /total --> */}
                  <div className="total">
                    <div className="text">Total to pay</div>
                    <div className="price">{formatCurrency(subTotal)}</div>
                    <div className="gst">Inclusive of GST where applicable</div>
                  </div>
                  {/* <!-- /total --> */}

                  <a
                    className="blackbutton"
                    onClick={() => {
                      if (methodRadio) {
                        getInvoice();
                      } else {
                        setShowMethodError(true);
                      }
                    }}
                  >
                    {is_loading ? (
                      <Loader
                        type="TailSpin"
                        color="white"
                        height={18}
                        width={18}
                      />
                    ) : (
                      "PLACE ORDER"
                    )}
                  </a>
                </div>
                {/* <!-- /order-summary --> */}
              </div>
              {/* <!-- /checkout-box --> */}
            </div>
            {/* <!-- /right --> */}
          </div>
          {/* <!-- /checkout --> */}
        </div>
        {/* <!-- /content--> */}
      </div>

      <Footer
        props={props}
        categoriesArray={props?.allCategories ? props?.allCategories : []}
      />

      <div className={`outofstock ${show_error_modal ? "active" : ""}`}>
        <div className="message">
          <div className="title">OUT OF STOCK</div>
          <div className="text">
            Sorry, the following product(s) are sold out:
            <br />- {errorDescription.split('"')[1]}
            <br />
          </div>
          <a className="blackbutton" onClick={() => setShow_error_modal(false)}>
            CLOSE
          </a>
          <a className="close" onClick={() => setShow_error_modal(false)}>
            <img src="images/icon-x.svg" alt="" />
          </a>
        </div>

        <div className="overlay"></div>
      </div>
    </div>
  );
}
const mapStateToProps = (state) => {
  const { cart_count, acf, allCategories } = state.UserReducer;
  return { cart_count, acf, allCategories };
};
const actions = {
  UpdateCartCount,
  userLogout,
  UpdateCartAmount,
  setACF,
};
export default connect(mapStateToProps, actions)(SelectPaymentMethod);
